import React from 'react'

const metrics = [
  {
    title: 'Registros',
    value: '15.235',
    diff: 12,
    prev: '13.345',
    isPositive: true,
  },
  {
    title: 'Registros físicos',
    value: '10.025',
    diff: 9,
    prev: '9.234',
    isPositive: true,
  },
  {
    title: 'Registros delivery',
    value: '5.210',
    diff: 1,
    prev: '5.102',
    isPositive: true,
  },
  {
    title: 'Usuarios únicos',
    value: '9.234',
    diff: 12,
    prev: '8.123',
    isPositive: true,
  },
  {
    title: 'Frecuencia promedio',
    value: '2,3',
    diff: -1,
    prev: '2,4',
    isPositive: false,
  },
]

const montserratStyle = { fontFamily: 'Montserrat, sans-serif', color: '#1E1E1E' }

export const GeneralMetrics = () => (
  <div className="flex gap-6 w-full">
    {metrics.map(m => (
      <div
        key={m.title}
        className="bg-white rounded-2xl shadow p-6 flex flex-col min-w-[200px]"
        style={montserratStyle}
      >
        <span className="text-base font-bold mb-1" style={montserratStyle}>
          {m.title}
        </span>
        <span className="text-3xl font-extrabold mb-2" style={montserratStyle}>
          {m.value}
        </span>
        <div className="flex items-center gap-2">
          <span
            className={`font-bold rounded-lg px-2 py-1 flex items-center text-base ${
              m.isPositive ? '' : ''
            }`}
            style={{
              ...montserratStyle,
              background: m.isPositive ? '#C1FD96CC' : '#FFDBDB',
              color: m.isPositive ? '#1E1E1E' : '#E53935',
            }}
          >
            {m.isPositive ? (
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#47B960"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="mr-1"
              >
                <path d="M6 15l6-6 6 6" />
              </svg>
            ) : (
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#E53935"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="mr-1"
              >
                <path d="M6 9l6 6 6-6" />
              </svg>
            )}
            {m.isPositive ? `↑${m.diff}%` : `↓${Math.abs(m.diff)}%`}
          </span>
          <span className="text-gray-600 text-base" style={montserratStyle}>
            ({m.prev} del mes anterior)
          </span>
        </div>
      </div>
    ))}
  </div>
)
